<template>
    <teleport to="#teleported">
        <div class="md-detail-info__mask" data-vow="vow_register_mask">
            <div v-if="isLogin" class="md-detail-info__popup" :class="theme">
                <h2 class="title">
                    {{ $t('md-sold-detail.emailVerificationRequired') }}
                </h2>
                <ul class="verify-info">
                    <li
                        v-html="
                            $t('md-sold-detail.toVerifyEmail', {
                                email: user.account
                            })
                        "
                    ></li>
                </ul>
                <div class="verify-tip">
                    <i class="iconfont icon-local2 icon"></i>
                    <span>{{ $t('md-sold-detail.verifyEmailTip') }} </span>
                </div>
                <div class="button-box">
                    <button
                        :disabled="resendSuccess"
                        class="site-button verify"
                        @click="toVerify"
                    >
                        {{ $t('md-sold-detail.verifyYourEmail') }}
                    </button>
                </div>
            </div>
            <div v-else class="md-detail-info__popup" :class="theme">
                <h2 class="title">
                    {{ $t('md-sold-detail.freeAccountRequired') }}
                </h2>
                <ul class="tip-box">
                    <li class="child">
                        <i class="iconfont icon-local2 icon"></i>
                        <span class="text">{{
                            $t('md-sold-detail.instantAccessToListing')
                        }}</span>
                    </li>
                    <li class="child">
                        <i class="iconfont icon-local2 icon"></i>
                        <span class="text">{{
                            $t('md-sold-detail.saveListingsAndSearches')
                        }}</span>
                    </li>
                    <li class="child">
                        <i class="iconfont icon-local2 icon"></i>
                        <span class="text">{{
                            $t('md-sold-detail.accessDetailsFor')
                        }}</span>
                    </li>
                </ul>
                <div class="button-box">
                    <button class="site-button login" @click="signIn">
                        {{ $t('md-sold-detail.signIn') }}
                    </button>
                    <button class="site-button register" @click="register">
                        {{ $t('md-sold-detail.register') }}
                    </button>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import signLog, { sendVowEmail } from '@/components/sign-log';
import { mapState as rootMapState } from 'pinia';
import { useUserStore } from "@/store";

import { mapState } from '@/store/helpers';
export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    data: function() {
        return {
            resendSuccess: false,
        };
    },
    props: ['theme'],
    computed: {
        isLogin() {
            return !!this.user;
        },
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        ...mapState({
            info: store => store.listingDetail.info || {}
        })
    },
    mounted() {
        //  no scrolling
        document.body.style.overflow = 'hidden';
    },
    methods: {
        maskStreetAddress(streetAddress) {
            if (!streetAddress && this.info.mlsOrg.id != 442) {
                return streetAddress; 
            }
            let address = '';
            let strAddArr = streetAddress.split(' ');
            if (strAddArr.length <= 3) {
                address = '*** ***' + strAddArr[strAddArr.length - 1];
            } else {
                strAddArr[0] = '***';
                strAddArr[1] = '***';
                address = strAddArr.join(' ');
            }
            return address;
        },
        signIn() {
            signLog.login({
                allowClose: true,
                languageTextFn: {
                    agreementHtml: _ =>
                        this.$t('md-sold-detail.byContinuingYouAgreeTo')
                }
            });
        },
        register() {
            signLog.register({
                allowClose: true,
                languageTextFn: {
                    agreementHtml: _ =>
                        this.$t('md-sold-detail.byContinuingYouAgreeTo')
                },
                onregister: (user, inquiry) => {
                    return false;
                },
                onsuccess: () => {
                    return false; //  Do not pop up the default prompt box
                }
            });
        },
        async toVerify() {
            this.resendSuccess = true;
            try {
                await sendVowEmail({ user: this.user, isResend: true });
            } catch (e) {
                //  Failed to send disabled ， If successful, keep grayed out
                this.resendSuccess = false;
            }
        }
    },
    unmounted() {
        //  can scroll
        document.body.style.overflow = '';
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';

.md-detail-info {
    position: relative;
}
.md-detail-info__mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    backdrop-filter: blur(6px);
    background-color: rgba(3, 10, 26, 0.85);
}
.md-detail-info__popup {
    width: 430px;
    background-color: #ffffff;
    padding: 30px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    --loginBtnColor: #505050;
    --loginBtnBorderColor: #e1e2e6;
    --loginBtnBgColor: #ffffff;
    &.classic {
        --titleColor: #202437;
        --tipColor: #191919;
    }
    &.standard {
        --titleColor: #202437;
        --tipColor: #202437;
    }
    &.broker {
        --titleColor: #202437;
        --tipColor: #202437;
    }
    &.fashion {
        --titleColor: #4a4a60;
        --tipColor: #4a4a60;
    }
    .title {
        color: var(--titleColor);
        font-size: 18px;
        font-family: var(--font-bold);
        text-align: center;
        margin-bottom: 25px;
        line-height: 20px;
    }
    .tip-box {
        font-size: 14px;
        color: var(--tipColor);
        .child {
            display: flex;
            .icon {
                color: var(--color-theme);
                margin-right: 8px;
                vertical-align: middle;
            }
            & + .child {
                margin-top: 15px;
            }
        }
    }
    .verify-info {
        font-size: 14px;
        color: var(--tipColor);
        line-height: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e1e2e6;
        margin-bottom: 20px;
        .bold {
            font-weight: bold;
        }
    }
    .verify-tip {
        display: flex;
        .icon {
            font-size: 12px;
            flex-shrink: 0;
            color: #8b93a7;
            margin: 3px 10px 0 0;
        }
        span {
            font-size: 12px;
            line-height: 18px;
            color: #7e8390;
        }
    }
    .button-box {
        margin-top: 25px;
        display: flex;
        button[disabled='disabled'] {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
    .site-button {
        height: 40px;
        line-height: 40px;
        text-align: center;
        flex: 1;
        &.login {
            border: solid 2px var(--loginBtnBorderColor);
            background-color: var(--loginBtnBgColor);
            color: var(--loginBtnColor);
            line-height: 36px;
            font-size: 18px;
        }
        &.register,
        &.verify {
            @include color-button-hover();
            font-size: 16px;
            font-family: var(--font-bold);
            @include color-button();
        }
        &.register {
            margin-left: 20px;
        }
    }
}
@include media-600 {
    .md-detail-info__popup {
        padding: 30px 15px 15px 15px;
        width: 300px;
        .button-box {
            display: flex;
            flex-direction: column-reverse;
            .site-button {
                &.register {
                    margin: 0;
                    margin-bottom: 20px;
                }
            }
        }
    }
}
</style>
